export const DoneMark = (props) => (
    <svg {...props} viewBox="0 0 141 139" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g style={{mixBlendMode:"hard-light"}} filter="url(#filter0_f_298_3717)">
        <ellipse cx="70.5" cy="69.5" rx="61.5" ry="60.5" fill="url(#paint0_radial_298_3717)" fillOpacity="0.6"/>
        </g>
        <g filter="url(#filter1_di_298_3717)">
        <path fillRule="evenodd" clipRule="evenodd" d="M71 116C98.6142 116 121 93.6142 121 66C121 38.3858 98.6142 16 71 16C43.3858 16 21 38.3858 21 66C21 93.6142 43.3858 116 71 116ZM103.357 51.6903C104.659 50.3885 104.659 48.278 103.357 46.9763C102.055 45.6745 99.9448 45.6745 98.6431 46.9763L64.3335 81.2859L50.0238 66.9763C48.7221 65.6745 46.6115 65.6745 45.3098 66.9763C44.008 68.278 44.008 70.3886 45.3098 71.6903L61.9764 88.357C63.2782 89.6587 65.3887 89.6587 66.6905 88.357L103.357 51.6903Z" fill="#F2E7F3"/>
        </g>
        <defs>
        <filter id="filter0_f_298_3717" x="0" y="0" width="141" height="139" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
        <feGaussianBlur stdDeviation="4.5" result="effect1_foregroundBlur_298_3717"/>
        </filter>
        <filter id="filter1_di_298_3717" x="17" y="16" width="108" height="108" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="4"/>
        <feGaussianBlur stdDeviation="2"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_298_3717"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_298_3717" result="shape"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="4"/>
        <feGaussianBlur stdDeviation="1.5"/>
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"/>
        <feBlend mode="normal" in2="shape" result="effect2_innerShadow_298_3717"/>
        </filter>
        <radialGradient id="paint0_radial_298_3717" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(70.5 69.5) rotate(90) scale(60.5 61.5)">
        <stop stopColor="#4E3B55"/>
        <stop offset="1" stopColor="#4E3B55" stopOpacity="0"/>
        </radialGradient>
        </defs>
    </svg>
)